import type { TravelerTierTag } from '~/content/traveler';
import { cn } from '~/lib/cn';

const tierClasses: Record<TravelerTierTag['tier'], string> = {
  platinum: 'bg-red-500',
  infinite: 'bg-gold',
};

/**
 * Card-tier labels under a traveler FeatureBlock heading (Figma 1303:52931).
 * Static tags drawn at the `md` button size, not buttons: they mark which card
 * the benefits below belong to.
 */
export function TravelerTierTags({ tags }: { tags: TravelerTierTag[] }) {
  return (
    <ul className="flex flex-wrap items-center gap-3">
      {tags.map((tag) => (
        <li
          key={tag.label}
          className={cn(
            'rounded-pill pt-[12px] pr-[14px] pb-[13px] pl-[14px] text-[16px] leading-[1.4] font-medium tracking-[0.192px] text-white',
            tierClasses[tag.tier],
          )}>
          {/* Label wrapped so text-box-trim applies, as in Button. */}
          <span>{tag.label}</span>
        </li>
      ))}
    </ul>
  );
}
